import { IUserApi } from "../../../infrastructure/apis/user";
import { LoginRequestDTO } from "../../../infrastructure/dtos/login";
import { type IUserService } from "./IUserService";

export class UserService implements IUserService {
    constructor(readonly userApi: IUserApi) {
    }

    public async login(loginRequestDTO: LoginRequestDTO): Promise<void> {
        await this.userApi.login(loginRequestDTO);
    }

    public async logout(): Promise<void> {
        await this.userApi.logout();
    }

    public async deleteAccount(): Promise<void> {
        await this.userApi.deleteAccount();
    }
}